const singleCookie = (name) => {
  const cookie = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookie ? cookie.pop() : null;
};

const get = (name) => {
  const cookie = singleCookie(name);
  return cookie;
};

const set = (name, value, days) => {
  if (days && typeof(days) !== 'number') throw new Error(`expiration day must be a number`);
  let expires = '';
  if (days) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    expires = date.toUTCString();
  }
  document.cookie = `${name}=${value};expires=${expires};`;
};

const remove = (name) => {
  set(name, '', -1);
};

const isPresent = (cookies) => {
  if (!(cookies instanceof Array)) throw new Error(`cookies must be an array`);
  else return cookies.every(singleCookie);
};

export default {
  get,
  set,
  remove,
  isPresent,
};



/** WEBPACK FOOTER **
 ** ./modules/cookie/index.js
 **/